<ng-container *ngIf="type !== 'currency'">
  <div [formGroup]="formGroup">
    <finx-input
      [type]="type"
      class="profile-input"
      [value]="value"
      [formGroup]="formGroup"
      [formControlName]="formControlName"
      [labelAsPlaceholder]="labelAsPlaceholder"
      [label]="label"
      [textColor]="textColor"
      [labelAsPlaceholder]="labelAsPlaceholder"
      [colorTextAlignStyle]="colorTextAlignStyle"
      [textInputFontStyle]="textInputFontStyle"
      [textInputBackgroundColor]="textInputBackgroundColor"
      [inputStyle]="combinedInputStyles"
      [readOnly]="disable"
      (focusEvent)="onFocusEvent($event)"
    ></finx-input>
  </div>
</ng-container>

<ng-container *ngIf="type === 'currency'">
  <div [formGroup]="formGroup">
    <finx-input
      id="input {{ label }}"
      [type]="type"
      class="profile-input"
      [value]="value"
      [formGroup]="formGroup"
      [formControlName]="formControlName"
      [label]="label"
      [placeholder]="currencySymbol"
      [textColor]="textColor"
      [labelAsPlaceholder]="labelAsPlaceholder"
      [colorTextAlignStyle]="colorTextAlignStyle"
      [textInputFontStyle]="textInputFontStyle"
      [textInputBackgroundColor]="textInputBackgroundColor"
      [inputStyle]="combinedInputStyles"
      [readOnly]="disable"
      (focusEvent)="onFocusEvent($event)"
    ></finx-input>
  </div>
</ng-container>
